module.exports = __webpack_public_path__ + "img/couples_04_V.f4763e32.webp";